import { useTranslation } from 'react-i18next';
import { formatPrice } from '../../utils/priceCalculator';

export default function ProductCard({ product, showPrices, selected, onToggleSelect, onSelect, onQuoteRequest }) {
    const { t } = useTranslation();

    return (
        <div className="ast-product-card" onClick={() => onSelect(product)} style={{ position: 'relative' }}>
            {onToggleSelect && (
                <label
                    className="ast-product-card__select"
                    onClick={(e) => e.stopPropagation()}
                    style={{ position: 'absolute', top: 8, left: 8, zIndex: 2, display: 'flex', alignItems: 'center', gap: 4, background: 'rgba(255,255,255,.9)', borderRadius: 4, padding: '2px 6px', cursor: 'pointer', fontSize: 12 }}
                    title="Selecteer voor offerte"
                >
                    <input
                        type="checkbox"
                        checked={!!selected}
                        onChange={() => onToggleSelect(product)}
                    />
                    <span>Offerte</span>
                </label>
            )}
            <div className="ast-product-card__image">
                {product.image_url ? (
                    <img src={product.image_url} alt={product.name} loading="lazy" />
                ) : (
                    <div className="ast-product-card__placeholder">
                        <span className="dashicons dashicons-cart"></span>
                    </div>
                )}
            </div>

            <div className="ast-product-card__body">
                {product.sku && (
                    <span className="ast-product-card__sku">{product.sku}</span>
                )}
                <h3 className="ast-product-card__name">{product.name}</h3>
                {product.description && (
                    <p className="ast-product-card__desc">
                        {product.description.length > 100
                            ? product.description.substring(0, 100) + '...'
                            : product.description}
                    </p>
                )}
            </div>

            <div className="ast-product-card__footer">
                {showPrices ? (
                    <>
                        <span className="ast-product-card__price">
                            {product.price_type === 'none'
                                ? ''
                                : product.price_type === 'on_request'
                                ? <span className="ast-price-on-request">Op nacalculatie</span>
                                : product.price_type === 'included'
                                ? t('price.priceOnRequest')
                                : formatPrice(product.price)}
                        </span>
                        <button
                            className="ast-btn ast-btn--primary ast-btn--sm"
                            style={{ marginLeft: '10px' }}
                            onClick={(e) => { e.stopPropagation(); onQuoteRequest(product); }}
                        >
                            {t('catalog.requestQuote')}
                        </button>
                    </>
                ) : (
                    <button
                        className="ast-btn ast-btn--primary ast-btn--sm ast-btn--full"
                        onClick={(e) => { e.stopPropagation(); onQuoteRequest(product); }}
                    >
                        {t('catalog.requestQuote')}
                    </button>
                )}
            </div>
        </div>
    );
}
